import React, { memo } from "react";
import PropTypes from "prop-types";
import Row from "../../../Common/Row";
import Table from "../../../Common/Table";

const Rows = memo(({ customer }) => {
	return (
		<>
			<Row label={`Uuid`} value={customer.uuid} />
			<Row label={`Brand`} value={customer.brand} />
			<Row label={`Created on`} value={customer.createdOn} />
			<Row label={`Accepted terms on`} value={customer.acceptedTermsOn} />
			<Row label={`Last login date`} value={customer.lastLogin} />
			<Row label={`Language`} value={customer.language} />
			<Row label={`Country`} value={customer.country} />
		</>
	);
});

const TechnicalDetails = memo(({ customer }) => {
	return (
		<Table title={`Technical details`}>
			<Rows customer={customer} />
		</Table>
	);
});
TechnicalDetails.displayName = `TechnicalDetails`;
TechnicalDetails.propTypes = {
	customer: PropTypes.object.isRequired
};
Rows.displayName = `Rows`;
Rows.propTypes = {
	customer: PropTypes.object.isRequired
};

export default TechnicalDetails;
